module.exports = __webpack_public_path__ + "static/media/tick-mark.db9b2342.png";